import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';
import './calendar-skeleton.scss';

const WEEKDAY_COUNT: number = 7;
const WEEK_ROW_COUNT: number = 6;

const CalendarSkeleton = () => (
  <div className="calendar-skeleton" aria-hidden>
    <div className="calendar-skeleton__toolbar">
      <div className="calendar-skeleton__toolbar-group">
        <Skeleton variant="rect" width="3rem" height="2.4rem" />
        <Skeleton variant="rect" width="5rem" height="2.4rem" />
        <Skeleton variant="rect" width="3rem" height="2.4rem" />
      </div>
      <Skeleton variant="text" width="14rem" />
      <div className="calendar-skeleton__toolbar-group">
        <Skeleton variant="rect" width="4rem" height="2.4rem" />
        <Skeleton variant="rect" width="4rem" height="2.4rem" />
        <Skeleton variant="rect" width="4rem" height="2.4rem" />
        <Skeleton variant="rect" width="4rem" height="2.4rem" />
      </div>
    </div>

    <div className="calendar-skeleton__weekday-row">
      {Array.from({ length: WEEKDAY_COUNT }, (_, index: number) => (
        <div key={`calendar-skeleton-weekday-${index}`} className="calendar-skeleton__weekday">
          <Skeleton variant="text" width="3rem" />
        </div>
      ))}
    </div>

    <div className="calendar-skeleton__grid">
      {Array.from({ length: WEEK_ROW_COUNT }, (_, rowIndex: number) => (
        <div key={`calendar-skeleton-row-${rowIndex}`} className="calendar-skeleton__row">
          {Array.from({ length: WEEKDAY_COUNT }, (_, colIndex: number) => {
            const showSecondaryEvent: boolean = (rowIndex + colIndex) % 4 === 0;
            const showPrimaryEvent: boolean = (rowIndex + colIndex) % 3 !== 0;

            return (
              <div
                key={`calendar-skeleton-cell-${rowIndex}-${colIndex}`}
                className="calendar-skeleton__cell"
              >
                <div className="calendar-skeleton__date">
                  <Skeleton variant="text" width="1.5rem" />
                </div>
                {showPrimaryEvent && (
                  <div className="calendar-skeleton__event">
                    <Skeleton variant="rect" width="100%" height="1.4rem" />
                  </div>
                )}
                {showSecondaryEvent && (
                  <div className="calendar-skeleton__event">
                    <Skeleton variant="rect" width="80%" height="1.4rem" />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  </div>
);

export default CalendarSkeleton;
